import React, { useState, useContext } from "react";
import {
    UiAuthContainer,
    UiAuthFooterContainer,
} from "../../_uiComponents/common/custom/header/UiTopNavElements";

import OtpVerification from "../auth/forms/OtpVerification";
import { participantUrl } from "../../../_redux/_constants";

export default function OtpWrapper(props) {
    const hostname = window.location.hostname
        .replace(".com", "")
        .split(".")
        .pop();
    const isTlc = hostname === participantUrl.RENAULT_TLC_URL;
    return (
        <>
            <UiAuthContainer>
                <div className={isTlc ? "sb-auth-top-wr sb-auth-top-wr-top-tlc" : "sb-auth-top-wr sb-auth-top-wr-top"}>
                    <h2>Otp Verification</h2>
                    <div className="sba-auth-top-heading">
                        <h5>
                            Please enter the OTP sent to your registered mobile
                            & email
                        </h5>
                    </div>
                    <OtpVerification />
                    <UiAuthFooterContainer />
                </div>
            </UiAuthContainer>
        </>
    );
}
